var gtm_id = '';
if( 'undefined' !== typeof DBK &&
    'undefined' !== typeof DBK.gtm_id ) {
    gtm_id = DBK.gtm_id;
}

var locale = $('html').attr('lang');
if( ! locale ) {
    locale = 'nl-NL';
}

// get parameter values from url
function GetURLParameter(sParam)
{
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) 
    {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) 
        {
            return sParameterName[1];
        }
    }
}

$('.booking-bar form').submit(function (e) {

    e.preventDefault();

    $('.mews-waiting-overlay').fadeIn(150);

    var form = $(this);

    var mews_ids = form.find( 'input[name=destination]:checked' ).val();

    if( 'string' === typeof( mews_ids ) ) {

        // MEWS id has been set as json encoded array in HTML attr value, convert it back
        mews_ids = jQuery.parseJSON( mews_ids );

        Mews.Distributor({
            configurationIds: mews_ids,
            gtmContainerId: gtm_id
        }, function (distributor) {
            // Some default settings
            distributor.setLanguageCode( locale );

            var arrive = form.find( 'input[name=arrive]' ).val();
            var arrive_parts = arrive.split( '-' );
            var start = new Date( arrive_parts[2], arrive_parts[1] - 1, arrive_parts[0] );

            var nr_of_nights = form.find( 'input[name=duration]:checked' ).val();
            var end = new Date();
            end.setDate( start.getDate() + parseInt( nr_of_nights ) );

            distributor.setStartDate( start );
            distributor.setEndDate( end );
            distributor.open();
            distributor.showRooms(); 

            setTimeout(() => {
                $('.mews-waiting-overlay').hide();
            }, 1000);

        }, {
            dataBaseUrl: 'https://api.mews.com' // set to https://api.mews-demo.com for testing
        });
    }

    return false;
});

// Should never occur.
if ('object' === typeof DBK &&
    'object' === typeof DBK.mews_hotels) {

    $('[data-trigger="booking"]').click(function (e) {

        $('.mews-waiting-overlay').fadeIn(150);

        var mews_ids = [];

        // Gather the distribution ids. One if hotel is chosen, multiple if no hotel is chosen
        DBK.mews_hotels.forEach(function (item, index) {
            mews_ids.push(item.mews_id)
        });

        Mews.Distributor({
            configurationIds: mews_ids,
            gtmContainerId: gtm_id
        }, function (distributor) {
            // Some default settings

            distributor.setStartDate( new Date( moment().day(6).format("YYYY, MM, DD") ) );

            distributor.setLanguageCode( locale );
            distributor.open();

            setTimeout(() => {
                $('.mews-waiting-overlay').hide();
            }, 1000);

        }, {
            dataBaseUrl: 'https://api.mews.com' // set to https://api.mews-demo.com for testing
        });

    });
}

$('a[data-mews-id]').click(function (e) {

    e.preventDefault();

    $('.mews-waiting-overlay').fadeIn(150);

    var anchor = $(this);

    Mews.Distributor({
        configurationIds: [anchor.data('mews-id')],
        gtmContainerId: gtm_id
    }, function (distributor) {
        // Some default settings
        distributor.setLanguageCode( locale );

        var arrive = anchor.data('mews-startdate');
        if( arrive ) {
            var arrive_parts = arrive.split( '-' );
            var start = new Date( arrive_parts[2], arrive_parts[1] - 1, arrive_parts[0] );
            distributor.setStartDate( start );

            var leave = anchor.data('mews-enddate');
            if( leave ) {
                var leave_parts = leave.split( '-' );
                var end = new Date( leave_parts[2], leave_parts[1] - 1, leave_parts[0] );
                distributor.setEndDate( end );
            }
        }

        distributor.open();
        distributor.showRooms(); 

        setTimeout(() => {
            $('.mews-waiting-overlay').hide();
        }, 1000);

    }, {
        dataBaseUrl: 'https://api.mews.com' // set to https://api.mews-demo.com for testing
    });
    return false;
});

// open mews engine from get url parameters if present
if (GetURLParameter(hotelAdsParameters.arrival) != undefined &&
    GetURLParameter(hotelAdsParameters.departure) != undefined &&
    GetURLParameter(hotelAdsParameters.guests) != undefined) {

    $('.mews-waiting-overlay').fadeIn(150);

    var mews_id = [];
    var mews_ids = []; 

    // pick right hotel mews id by comparing it to post id
    DBK.mews_hotels.forEach(function (item, index) {
        if (DBK.postid == item.hotel_post_id) {
            mews_id.push(item.mews_id)
        }
        mews_ids.push(item.mews_id); 
    });

    if (mews_id.length === 0) {
        mews_id = mews_ids; 
    }

    Mews.Distributor({
        configurationIds: mews_id,
        gtmContainerId: gtm_id
    }, function (distributor) {
        // Some default settings

        // date format in url (DD-MM-YYYY)
        var arrive = GetURLParameter(hotelAdsParameters.arrival);
        var arrive_parts = arrive.split( '-' ); 
        var start = new Date( arrive_parts[2], arrive_parts[1] - 1, arrive_parts[0] );

        var leave = GetURLParameter(hotelAdsParameters.departure);
        var leave_parts = leave.split( '-' ); 
        var end = new Date( leave_parts[2], leave_parts[1] - 1, leave_parts[0] );
           
        var nr_of_persons = GetURLParameter(hotelAdsParameters.guests); 

        distributor.setLanguageCode( locale );
        distributor.setStartDate( start );
        distributor.setEndDate( end );
        distributor.open();

        // show rooms foor given date
        distributor.showRooms(); 

        setTimeout(() => {
            $('.mews-waiting-overlay').hide();
        }, 1000);

    }, {
        dataBaseUrl: 'https://api.mews.com' // set to https://api.mews-demo.com for testing
    });
}





